import { Injectable, InjectionToken } from '@angular/core';

export interface StoragePort {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  clear(): void;
}

export const LOCAL_STORAGE_PORT = new InjectionToken<StoragePort>('LOCAL_STORAGE_PORT');
export const SESSION_STORAGE_PORT = new InjectionToken<StoragePort>('SESSION_STORAGE_PORT');

@Injectable({
  providedIn: 'root',
})
export class LocalStorageAdapter implements StoragePort {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  clear(): void {
    localStorage.clear();
  }
}

@Injectable({
  providedIn: 'root',
})
export class SessionStorageAdapter implements StoragePort {
  getItem(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
